"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.agentChatConversationFilterSchema = void 0;
const QueryBuilder_1 = require("../QueryBuilder");
exports.agentChatConversationFilterSchema = (0, QueryBuilder_1.createFilterSchema)({
    fields: {
        agentId: {
            description: 'Agent identifier the conversation is bound to (e.g. cadstrom-project-assistant).',
            options: { type: QueryBuilder_1.FieldType.String, nonNullable: true },
        },
        sessionId: {
            description: 'Client-supplied session identifier captured at conversation creation.',
            options: { type: QueryBuilder_1.FieldType.String, nonNullable: true },
        },
        title: {
            description: 'Human-readable conversation title. Null until generated.',
            options: { type: QueryBuilder_1.FieldType.String },
        },
        lastActivityAt: {
            description: 'Timestamp of the most recent activity. Sort-only.',
            options: {
                type: QueryBuilder_1.FieldType.Custom,
                buildWhere: () => ({}),
                buildOrderBy: (direction) => [{ lastActivityAt: direction }],
            },
            allowedOperators: [],
        },
        createdAt: {
            description: 'Timestamp the conversation row was created. Sort-only.',
            options: {
                type: QueryBuilder_1.FieldType.Custom,
                buildWhere: () => ({}),
                buildOrderBy: (direction) => [{ createdAt: direction }],
            },
            allowedOperators: [],
        },
    },
});
//# sourceMappingURL=filter-schemas.js.map